import React, { Fragment } from 'react';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle
} from '@material-ui/core';
import { getPrimary, getSecondary } from '../styles/colors';
import { isMobile } from '../utils/screen';
import BasicButton from './BasicButton';

const AlertConfirm = ({
	title,
	fullWidth,
	fullScreen,
	buttonAccept,
	buttonCancel,
	successAction = false,
	open,
	requestClose,
	loadingAction,
	acceptAction,
	cancelAction,
	bodyText,
	bodyStyle = {},
	hideAccept,
	extraActions,
	classNameDialog,
	PaperProps,
	widthModal,
	titleRight,
	actions
}) => {
	const primary = getPrimary();
	const buttons = (
		<Fragment>
			{!!buttonCancel && (
				<BasicButton
					text={buttonCancel}
					textStyle={{
						textTransform: 'none',
						fontWeight: '700',
					}}
					primary={true}
					color='transparent'
					type='text'
					onClick={cancelAction || requestClose}
				/>
			)}

			{extraActions &&
				extraActions
			}

			{!hideAccept && !!buttonAccept && (
				<BasicButton
					text={buttonAccept}
					loading={loadingAction}
					success={successAction}
					textStyle={{
						color: 'white',
						textTransform: 'none',
						fontWeight: '700'
					}}
					buttonStyle={{ marginLeft: '1em' }}
					color={primary}
					onClick={acceptAction}
					claseHover={'buttonAceptarDeModalAlert'}
				/>
			)}
		</Fragment>
	);

	return (
		<Dialog
			className={classNameDialog}
			fullWidth={isMobile || fullWidth}
			fullScreen={fullScreen}
			maxWidth={false}
			open={open}
			onClose={requestClose}
			PaperProps={{
				style: { ...widthModal, ...(PaperProps ? PaperProps.style : {}) },
			}}
		>
			{!!requestClose && (
				< i
					className={'fa fas-close'}
					style={{
						cursor: 'pointer',
						fontSize: '1.5em',
						color: getSecondary(),
						position: 'absolute',
						right: '12px',
						top: '18px'
					}}
					onClick={requestClose}
				/>
			)}
			{!!title && (
				<DialogTitle
					style={{
						margin: '0px 8px 0.8em',
						padding: '1.1em 2em 1.1em 1em',
						fontSize: '1.2em',
						borderBottom: '1px solid gainsboro',
						overflow: 'hidden'
					}}
				>
					{titleRight ?
						(
							<div style={{ display: 'flex', width: '95%', justifyContent: 'space-between' }}>
								<div>{title}</div>
								<div style={{ color: ' rgba(0, 0, 0, 0.37)', fontSize: '17px' }}>{titleRight}</div>
							</div>
						)
						:
						(
							title
						)
					}
				</DialogTitle>
			)}

			<DialogContent
				style={{
					minWidth: '40vw',
					maxWidth: '95vw',
					...bodyStyle
				}}
			>
				{bodyText}
			</DialogContent>
			{(!!buttonCancel || !!buttonAccept) &&
				<DialogActions
					style={{
						paddingRight: '0.6em',
						borderTop: '1px solid gainsboro',
						paddingTop: '0.5em',
						margin: '8px 8px',
						minHeight: '25px'
					}}
				>
					{buttons}
				</DialogActions>
			}
			{actions &&
				<DialogActions
					style={{
						paddingRight: '0.6em',
						borderTop: '1px solid gainsboro',
						paddingTop: '0.5em',
						margin: '8px 8px',
						minHeight: '25px'
					}}
				>
					{actions}
				</DialogActions>
			}
		</Dialog>
	);
};

export default AlertConfirm;
